<template>
    <div class="box">
        <multiselect
            v-model="value"
            :placeholder="placeholder"
            track-by="id"
            class="category-select"
            :custom-label="customLabel"
            :options="allCategories"
            @select="selectedCategory">
            <span class="limit">No puede seleccionar más categorías</span>
            <span slot="noResult">No hemos encontrado categorías</span>
            <span slot="noOptions">No hemos encontrado categorías</span>
        </multiselect>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'CategoryFilter',
    components: {
        Multiselect
    },
    data () {
        return {
            placeholder: 'Todas las categorías',
            value: [],
            categories: [{'name': 'Todas las categorías', 'id': 0}]
        }
    },
    mounted: function(){
        this.categoriesRequest();
    },
    methods: {
        customLabel ({ name, identifier }) {
            return `${name}`
        },
        selectedCategory: function(option, id){
            this.placeholder = option.name
            this.$emit('category-selected', option.id)
        },
        ...mapActions({
            'categoriesRequest': 'offers/getCategories'
        })
    },
    computed: {
        allCategories: function(){
            this.categories = [{'name': 'Todas las categorías', 'id': 0}]
            this.categories.push(...this.getCategories)
            return this.categories
        },
        ...mapGetters({
            'getCategories': 'offers/getCategories'
        })
    },
}
</script>

<style lang="sass">
</style>